<template>
  <div class="md-layout dashboard-grid">
    <div class="md-layout md-layout-item md-size-100">
      <div class="md-layout-item md-size-40 dashboard-column">
        <enquiry-follow-ups></enquiry-follow-ups>
        <overdue-bookings></overdue-bookings>
      </div>

      <div class="md-layout-item md-size-30 dashboard-column">
        <upcoming-departures></upcoming-departures>
        <new-bookings></new-bookings>
      </div>

      <div class="md-layout-item md-size-30 dashboard-column">
        <monthly-stats></monthly-stats>
        <enquiry-conversions></enquiry-conversions>
      </div>
    </div>
  </div>
</template>
<script>
import EnquiryFollowUps from "./Widgets/EnquiryFollowUps.vue";
import UpcomingDepartures from "./Widgets/UpcomingDepartures.vue";
import NewBookings from "./Widgets/NewBookings.vue";
import MonthlyStats from "./Widgets/MonthlyStats.vue";
import EnquiryConversions from "./Widgets/EnquiryConversions.vue";
import OverdueBookings from "./Widgets/OverduePayments.vue";

export default {
  components: {
    EnquiryFollowUps,
    UpcomingDepartures,
    NewBookings,
    MonthlyStats,
    EnquiryConversions,
    OverdueBookings
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

.dashboard-grid {
  padding: 2rem;
}

.dashboard-grid ::v-deep .md-card {
  margin: 15px 0;
}

.dashboard-grid ::v-deep .md-card-header + .md-card-content {
  padding-top: 0;
}
</style>
